import * as z from 'zod';

import { systemUserQueryLinkerSchema } from '@/_pages/system-users/shared';
import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';

/**
 * Backend model: revenue_lockdowns
 * - lock_start_date/lock_end_date are inclusive
 */
export const revenueLockdownCreatedBySchema = systemUserQueryLinkerSchema.extend({
  // id: z.number(),
  // name: z.string(),
  // first_name: z.string().nullable(),
  // last_name: z.string().nullable(),
  // email: z.string().nullable(),
  // username: z.string().nullable(),
  // status: z.string().nullable(),
  user_type: z.string().nullable(),
  team_member_id: z.number().nullable(),
  microsoft_groups: z.string().nullable(),
  country_id: z.number().nullable(),
});

export type RevenueLockdownCreatedBySchema = z.infer<typeof revenueLockdownCreatedBySchema>;

export const revenueLockdownQuerySchema = z.object({
  id: z.number(),
  name: z.string().nullable(),
  lock_start_date: z.string(),
  lock_end_date: z.string(),
  creator_id: z.number().nullable(),
  created_at: z.string().nullable(),
  updated_at: z.string().nullable(),
  deleted_at: z.string().nullable(),
  created_by: revenueLockdownCreatedBySchema.nullable().optional(),
});

export type RevenueLockdownQuerySchema = z.infer<typeof revenueLockdownQuerySchema>;

/**
 * Backwards-compatible alias for existing FE usage.
 */
export const revenueLockdownSchema = revenueLockdownQuerySchema;
export type RevenueLockdownSchema = RevenueLockdownQuerySchema;

export const revenueLockdownAllQuerySchema = paginatedResponseSchema(revenueLockdownQuerySchema);
export type RevenueLockdownAllQuerySchema = z.infer<typeof revenueLockdownAllQuerySchema>;
